import React from "react";

export default function Thread() {
  return (
    <section className="page-center padding40tb" style={{ maxWidth: 900, margin: "0 auto" }}>
      
      {/* Header */}
      <header style={{ textAlign: "center", marginBottom: 30 }}>
        <h2>Embroidery Thread Types</h2>
      </header>

      {/* Intro */}
      <div style={{ textAlign: "center", marginBottom: 30 }}>
        <h3>Main Thread Types</h3>
        <p>
          There are two primary thread types used for embroidery: rayon and polyester. The choice depends on the design, the fabric, and the desired finish. Both threads offer unique benefits to ensure your logo or design looks its best.
        </p>
        
        <p style={{ color: "#c43235", fontWeight: "bold" }}>
          Rayon | Polyester
        </p>
      </div>

      {/* Rayon Thread */}
      <div style={{ display: "flex", alignItems: "flex-start", marginBottom: 25 }}>
        <img
          src="https://www.sharprint.com/hs-fs/hubfs/Sharprint/Website/Website_Pages/Embroidery/Embroidery_Thread_Types/Embroidery_Thread_Types_Rayon_Sharprint.jpg?width=125"
          alt="Rayon Thread"
          style={{ width: 125, marginRight: 20 }}
        />
        <div>
          <h4>Rayon Thread</h4>
          <ul>
            <li>Shiny, smooth, and ideal for delicate fabrics.</li>
            <li>Commonly used for corporate apparel and retail garments.</li>
          </ul>
        </div>
      </div>

      {/* Polyester Thread */}
      <div style={{ display: "flex", alignItems: "flex-start", marginBottom: 25 }}>
        <img
          src="https://www.sharprint.com/hs-fs/hubfs/Sharprint/Website/Website_Pages/Embroidery/Embroidery_Thread_Types/Embroidery_Thread_Types_Polyester_Sharprint.jpg?width=125"
          alt="Polyester Thread"
          style={{ width: 125, marginRight: 20 }}
        />
        <div>
          <h4>Polyester Thread</h4>
          <ul>
            <li>Less shiny than rayon but highly durable.</li>
            <li>Perfect for sports uniforms and heavy-use apparel.</li>
          </ul>
        </div>
      </div>

      {/* Thread Colors */}
      <div style={{ marginTop: 40 }}>
        <h3 style={{ textAlign: "center", marginBottom: 20 }}>Thread Colors</h3>
        <p>
          Our artists and digitizers match threads to your chosen Pantone color. If no specific color is provided, we select the closest match from the design file. Please note that colors may appear slightly different on monitors.
        </p>
        <p>
          Thread charts are available in-store for your convenience. Some specialty threads are also offered, including metallic, rainbow, color-changing, reflective, neon, and glow-in-the-dark options. Not all threads are suitable for every design or fabric, so consult with your representative for guidance.
        </p>
      </div>
    </section>
  );
}
